var metadata;

function deepFreeze(object) {
  var propNames = Object.getOwnPropertyNames(object);

  for (let name of propNames) {
    let value = object[name];

    object[name] = value && typeof value === 'object' ?
      deepFreeze(value) : value;
  }

  return Object.freeze(object);
}

export default {
  setMetadata : function(val) {
    if (metadata)
      throw new Error('Metadata already set!');

    metadata = deepFreeze(val);
  },

  getErrorCodes : function() {
    return metadata.errorCodes;
  },

  getRequestGroupNames : function() {
    return Object.keys(metadata.requestGroups);
  },

  getRequestGroupDefinition : function(requestGroup) {
    return metadata.requestGroups[requestGroup];
  },

  getMethodDefinition : function(requestGroup, requestType) {
    return this.getRequestGroupDefinition(requestGroup).methods[requestType];
  },

  getResultDefinition : function(requestGroup, requestType) {
    return this.getMethodDefinition(requestGroup, requestType).resultDefinition;
  }
};
